export default __webpack_public_path__ + "img/54a467adacf8e9aff54a49da71cc2f8e.svg";